import { NavLink, Navigate, Outlet } from "react-router-dom";
import { LayoutGrid, Package, ShoppingCart, LogOut, ExternalLink, RefreshCw, Star } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  ["/admin", "Dashboard", LayoutGrid, "dashboard"],
  ["/admin/prodotti", "Prodotti", Package, "products"],
  ["/admin/ordini", "Ordini", ShoppingCart, "orders"],
  ["/admin/recensioni", "Recensioni", Star, "reviews"],
  ["/admin/amazon", "Amazon", RefreshCw, "amazon"],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <p className="p-10 tag">Caricamento...</p>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-[#FBFBFB]" data-testid="admin-layout">
      <aside className="md:w-60 border-b md:border-b-0 md:border-r border-[#0F0F0F] bg-white flex md:flex-col">
        <div className="p-5 border-r md:border-r-0 md:border-b border-[#0F0F0F]">
          <p className="font-display font-black text-xl tracking-tight">SCONTO<span className="text-[#FF3333]">.</span>MARKET</p>
          <span className="tag text-[#0033FF]">Admin</span>
        </div>
        <nav className="flex md:flex-col flex-1 overflow-x-auto">
          {LINKS.map(([to, label, Icon, id]) => (
            <NavLink
              key={to}
              to={to}
              end
              data-testid={`admin-nav-${id}`}
              className={({ isActive }) => `flex items-center gap-3 px-5 py-3 text-sm border-b border-[#0F0F0F]/10 ${isActive ? "bg-[#0F0F0F] text-white" : "hover:bg-[#0F0F0F] hover:text-white"}`}
            >
              <Icon size={16} strokeWidth={1.5} /> {label}
            </NavLink>
          ))}
          <a href="/" target="_blank" rel="noreferrer" data-testid="admin-nav-store" className="flex items-center gap-3 px-5 py-3 text-sm hover:bg-[#0F0F0F] hover:text-white">
            <ExternalLink size={16} strokeWidth={1.5} /> Negozio
          </a>
        </nav>
        <button data-testid="admin-logout-button" onClick={logout} className="flex items-center gap-3 px-5 py-4 text-sm md:border-t border-[#0F0F0F] hover:bg-[#FF3333] hover:text-white">
          <LogOut size={16} strokeWidth={1.5} /> Esci
        </button>
      </aside>
      <main className="flex-1 p-5 md:p-8 overflow-x-auto"><Outlet /></main>
    </div>
  );
}
